var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6099 83.4763C34.6099 83.4763 60.0879 82.456 65.5938 40.5756C70.4831 3.38172 113.446 20.311 125.865 35.1374C141.952 54.3436 133.376 87.3825 154.188 91.5563C174.999 95.73 161.409 142.135 129.818 137.693C90.5212 132.168 100.029 155.131 88.2321 164.85C79.7658 171.826 45.0508 165.111 43.8938 139.789C42.9202 118.481 33.9319 118.548 27.561 116.132C18.3727 112.648 12.5831 87.4111 34.6099 83.4763Z",
    fill: "#F0F8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.219 129.987L96.1875 105.253L91.2309 110.269L116.262 135.003L121.219 129.987Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.78 136.633L111.306 117.39C111.197 117.283 111.023 117.284 110.915 117.392L103.544 124.852C103.437 124.96 103.438 125.135 103.547 125.242L123.021 144.485C123.13 144.592 123.304 144.591 123.412 144.483L130.783 137.024C130.89 136.915 130.889 136.74 130.78 136.633Z",
    fill: "#1285C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0014 117.692C91.2222 117.692 105.182 103.732 105.182 86.5112C105.182 69.2903 91.2222 55.3301 74.0014 55.3301C56.7806 55.3301 42.8203 69.2903 42.8203 86.5112C42.8203 103.732 56.7806 117.692 74.0014 117.692Z",
    fill: "#1285C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9996 112.605C88.4105 112.605 100.093 100.922 100.093 86.5113C100.093 72.1003 88.4105 60.418 73.9996 60.418C59.5886 60.418 47.9062 72.1003 47.9062 86.5113C47.9062 100.922 59.5886 112.605 73.9996 112.605Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEmpty);
export default __webpack_public_path__ + "static/media/search_empty.db7643511401954762c18ac270a15f82.svg";
export { ForwardRef as ReactComponent };